<template lang="jade">
  modal(:name="modalName", @before-open="beforeOpen", @closed="close", ref="modal")
    .modal-mask
      .modal-wrapper
        .modal-container
          .header
            h3 Selecionar Jornada

          .close
            a.glyphicon.glyphicon-remove.a-without-decoration(style="left: 20px; position: relative;", @click="close")

          .select
            .jrn-head.jrn-row
              .jrn-row-item.to-click(@click="onClickOrderBy('name')", style="width: 30%;")
                h4(:class="orderByClassFor('name')") Nome
              .jrn-row-item.to-click(@click="onClickOrderBy('start')")
                h4(:class="orderByClassFor('start')") Entrada
              .jrn-row-item.to-click(@click="onClickOrderBy('stPause')")
                h4(:class="orderByClassFor('stPause')") Pausa
              .jrn-row-item.to-click(@click="onClickOrderBy('endPause')")
                h4(:class="orderByClassFor('endPause')") Retorno Pausa
              .jrn-row-item.to-click(@click="onClickOrderBy('end')")
                h4(:class="orderByClassFor('end')") Saída
              .jrn-row-item
                h4 Duração Legal
              .jrn-row-item
                h4 Duração

            .jrn-head.jrn-row
              .jrn-row-item.jrn-picker-filter(style="width: 30%;")
                input.form-control(type="text", placeholder="Filtrar jornada...", v-model="filterByName", v-focus=""
                v-focus-el="{right: 'filterStart', refs: $refs}", ref="filterName", @keydown="focusFirstItem", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByStart", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterName', right: 'filterStPause', refs: $refs}", ref="filterStart", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByStPause", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterStart', right: 'filterEndPause', refs: $refs}", ref="filterStPause", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByEndPause", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterStPause', right: 'filterEnd', refs: $refs}", ref="filterEndPause", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByEnd", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterEndPause', right: 'filterLegalDura', refs: $refs}", ref="filterEnd", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByLglDura", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterEnd', right: 'filterDuration', refs: $refs}", ref="filterLegalDura", :masked="true")

              .jrn-row-item.jrn-picker-filter
                the-mask.form-control(type="text", mask="##:##", placeholder="00:00", v-model="filterByDuration", @keyup.native="focusFirstItem",
                v-focus-el="{left: 'filterLegalDura', refs: $refs}", ref="filterDuration", :masked="true")


            hr(style="margin: 10px auto")

            SelectorPW(v-if="isDataAvailable", :items="computedData", :item-height="35", :onSelect="selfOnClickRow", height="500px",
              :elPrevFocus="focusSearchName", ref="selectorPw")
              template(slot-scope="{ item, index }")
                .jrn-row.to-click(@click="selfOnClickRow(item)", :key="index")
                  .jrn-row-item-name
                    span {{ item.name }}
                  .jrn-row-item
                    span.label.label-default {{ item.start }}
                  .jrn-row-item
                    span.label.label-default {{ item.stPause }}
                  .jrn-row-item
                    span.label.label-default {{ item.endPause }}
                  .jrn-row-item
                    span.label.label-default {{ item.end }}
                  .jrn-row-item
                    span.label.label-info {{ item.lglDura }}
                  .jrn-row-item
                    span.label.label-info {{ item.duration }}

            template(v-else)
              | Carregando...

            hr
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import InputText from './InputText'
import SelectorPW from './HelpersPW/SelectorPW.vue'
import moment from 'moment'
import { datetimeToTimeString, floatToHoursMinsString, inputTimeTofloat } from '../../utils'

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1)

const keyNames = ['name', 'start', 'stPause', 'endPause', 'end', 'lglDura', 'duration']

export default {
  name: 'journey-picker',
  components: { VirtualList, JourneyInputText: InputText, SelectorPW },
  props: {
    useState: { type: String, required: false },
    onClickRow: { default: null },
    loadCallback: { default: null },
    journeys: {},
    modalName: {'default': 'journey-picker'}
  },
  data () {
    return {
      dataLoaded: null,
      filterByName: '',
      filterByStart: '',
      filterByStPause: '',
      filterByEndPause: '',
      filterByEnd: '',
      filterByLglDura: '',
      filterByDuration: '',
      orderBy: '',
      orderType: '+',
      registredCallback: null,
      registredOnCloseNoSelect: null
    }
  },
  computed: {
    computedData () {
      if (!this.isDataAvailable && !this.journeys) return []
      const data = this.dataLoaded || this.journeys
      let computed = data.map((jrn) => {
        return {
          id: jrn.id,
          name: jrn.name,
          start: jrn.kind !== -1 ? datetimeToTimeString(jrn.start) : '--:--',
          stPause: jrn.kind !== -1 ? datetimeToTimeString(jrn.stPause) : '--:--',
          endPause: jrn.kind !== -1 ? datetimeToTimeString(jrn.endPause) : '--:--',
          end: jrn.kind !== -1 ? datetimeToTimeString(jrn.end) : '--:--',
          lglDura: jrn.lglDura < 0 || jrn.kind === -1 ? '--:--' : floatToHoursMinsString(jrn.lglDura),
          fullData: {...jrn},
          duration: this.calculateDura(jrn)
        }
      })
      // FILTER BY
      keyNames.forEach(k => {
        const key = `filterBy${capitalize(k)}`
        if (this[key] !== '' && this[key] !== undefined) {
          computed = computed.filter(value => value[k].toLowerCase().startsWith(this[key].toLowerCase()))
        }
      })
      // ORDER BY
      if (this.orderBy !== '' && this.orderBy !== undefined) {
        computed = computed.sort((a, b) => {
          let r = 0
          if (a[this.orderBy] === b[this.orderBy]) r = 0
          if (this.orderBy === 'name') {
            r = a[this.orderBy] < b[this.orderBy] ? -1 : 1
          } else {
            r = inputTimeTofloat(a[this.orderBy]) < inputTimeTofloat(b[this.orderBy]) ? -1 : 1
          }
          return this.orderType === '-' ? r * -1 : r
        })
      }
      return computed
    },
    isDataAvailable () {
      return this.dataLoaded !== null || this.journeys !== undefined
    }
  },
  methods: {
    selfOnClickRow (jrn) {
      if (this.onClickRow) {
        this.onClickRow(jrn.fullData)
        this.$emit('close')
      } else if (this.registredCallback) {
        this.registredCallback(jrn.fullData)
      } else {
        throw new Error('JourneyPicker dont received a callback')
      }
    },
    onClickOrderBy (name) {
      if (this.orderBy === name) {
        this.orderType = this.orderType === '+' ? '-' : '+'
      } else {
        this.orderType = '+'
        this.orderBy = name
      }
    },
    takeClass (number) {
      return (number % 2 === 0 ? 'even' : 'odd')
    },
    orderByClassFor (name) {
      if (this.orderBy === name) {
        return this.orderType === '+' ? 'st-sort-ascent' : 'st-sort-descent'
      } else {
        return ''
      }
    },
    focusFirstItem (e) {
      if (e.key === 'ArrowDown') {
        this.$refs.selectorPw.focusFirst()
      }
    },
    calculateDura ({ start, stPause, endPause, end }) {
      // console.log('calculating ', start, stPause, endPause, end)
      // const result = floatToHoursMinsString(
      //   Math.abs(Math.abs(inputTimeTofloat(end) - inputTimeTofloat(start)) - Math.abs(inputTimeTofloat(endPause) - inputTimeTofloat(stPause)))
      // )
      const result = floatToHoursMinsString(
        moment.duration(moment(end).diff(moment(start)) - moment(endPause).diff(moment(stPause))).asHours()
      )
      return result === '00:00' ? '--:--' : result
    },
    beforeOpen (event) {
      if (event.params) {
        this.registredCallback = event.params.callback
        this.registredOnCloseNoSelect = event.params.onCloseNoSelect
      }
    },
    close () {
      if (!this.registredOnCloseNoSelect) {
        this.$emit('close')
      } else {
        this.registredOnCloseNoSelect()
      }
      this.$modal.hide(this.modalName)
    },
    focusSearchName () {
      this.$refs.filterName.focus()
    }
  },
  async mounted () {
    if (!this.journeys) {
      let result = await this.loadCallback({})
      this.dataLoaded = result.body.success
      this.$modal.show(this.modalName)
    }
  }
}
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    box-sizing: border-box;
    opacity: 1;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 80%;
    display: grid;
    grid-template-columns: 5fr 5fr 5fr 5fr 1fr;
    grid-auto-rows: minmax(30px, auto);
    grid-gap: 0.2em;
    justify-items: stretch;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    grid-template-areas:
      "header header header header close"
      "select select select select select"
  }

  .header {grid-area: header;}
  .select {grid-area: select;}
  .form {grid-area: form;}
  .inputs {grid-area: inputs;}
  .options {grid-area: options; text-align: left; padding-top: 10px;}
  .close {grid-area: close; width: fit-content; margin: auto}

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media(max-width: 850px) {
    .pontos-input {
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "entrada pausa"
        "retorno saida"
    }
    .modal-container {
      grid-template-columns: 8fr 8fr 1fr;
      grid-template-areas:
        "header header close"
        "select select select"
        "form form form"
        "inputs inputs inputs"
        ". options options"
        ". . save";
    }
  }

  .jrn-row {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 35px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .even {
    background-color: transparent;
  }
  .odd {
    background-color: rgba(0,0,0,0.1);
  }
  .jrn-row-item-name {
    width: 30%;
    text-align: left;
    text-indent: 20px;
    min-height: 30px;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .jrn-row-item-name:hover {
    animation-play-state: running;
    animation: marquee 7s linear infinite;
  }
  @keyframes marquee {
    0% { text-indent: 20px }
    100% { text-indent: -9em }
  }
  .jrn-row-item-name:not( :hover ) {
    -webkit-animation: notexistent;
    animation: notexistent;
  }

  .jrn-row-item {
    width: 17%;
    box-sizing: border-box;
    text-align: center;
    height: 30px;
  }
  .jrn-head {
    box-sizing: border-box;
  }

  @media (max-width: 1024px) {
    .jrn-row-item-name {
      overflow: -webkit-paged-x;
    }
  }

  .filter-journey {
    width: 30%;
    margin-bottom: 5px;
  }
  .jrn-picker-filter {
    padding: 0 10px;
  }
</style>




// WEBPACK FOOTER //
// JourneyPicker.vue?7b4416c6